import { DevicePlatform } from '@/constants/enums'
import { SESSION, SHARED, CACHE_KEY } from '@/constants/constants'
import { locale } from '@/util'

export const uiHelper = {
  /* Page */
  setSchema,
  setMetaTag,
  setTitle,
  setCanonical,
  setHreflangLinks,
  setHreflangLinksen,
  setHreflangLinksbd,
  getPlatform,
  getHostname,
  getHost,
  IsIos,
  /* Currency */
  getCurrency,
  setCurrency,
  /* language */
  getLanguage,
  setLanguage,
  /* Cookie */
  getCookie,
  setCookie,
  removeCookie,
  getPopup,
  getLoginPopup,
  /* Local Storage With Expiry */
  getLocalStorage,
  setLocalStorage,
  /* Dialog Obj Initialize */
  initializePageDialogProperty,

  isAuthenticated,
  openPopup,
  openPopupInIframe,
  openNewTab,
  getFingerprints,
  downloadAPK,
  isAndroid,
  getDialCode,
  getRegionLocale,
  pushSportRadarRetargeting
}
function pushSportRadarRetargeting(gameObj, type, provider) {
  try {
    let _mediaUrl = SHARED.MEDIA_SERVER_URL
    let gametype = ''
    switch (type) {
      case 'ld':
        gametype = 'casino'
        break
      case 'rng':
        gametype = 'slot'
        break
      case 'fishing':
        gametype = 'fising'
        break
      case 'sb':
        gametype = 'sportsbook'
        break
      case 'special':
        gametype = 'slot'
        break
      case 'table':
        gametype = 'table'
        break
      case 'cricket':
        gametype = 'cricket'
        break
      case 'crash':
        gametype = 'crash'
        break
      case 'lottery':
        gametype = 'lottery'
        break
    }

    if (type == 'ld') {
      if (gameObj === null || gameObj === undefined) {
        let gameCacheKey = CACHE_KEY.GAME_LIST + '_' + this.getPlatform() + '_' + this.getCurrency() + '_ld'
        let storageLdGames = this.getLocalStorage(gameCacheKey)
        if (storageLdGames) {
          gameObj = storageLdGames.find(x => x.provider == provider)
        }
      }
    } else if (type == 'sb') {
      if (gameObj === null || gameObj === undefined) {
        let gameCacheKey = CACHE_KEY.GAME_LIST + '_' + this.getPlatform() + '_' + this.getCurrency() + '_sb'
        let storageSbGames = this.getLocalStorage(gameCacheKey)
        if (storageSbGames) {
          gameObj = storageSbGames.find(x => x.provider == provider)
        }
      }
    } else if (type == 'cricket') {
      if (gameObj === null || gameObj === undefined) {
        let gameCacheKey = CACHE_KEY.GAME_LIST + '_' + this.getPlatform() + '_' + this.getCurrency() + '_cricket'
        let storageCricketGames = this.getLocalStorage(gameCacheKey)
        if (storageCricketGames) {
          gameObj = storageCricketGames.find(x => x.provider == provider)
        }
      }
    }

    console.log(gameObj)
    if (!gameObj) {
      /* from pagenavigator / non gamepage , unable to get from localStorage cause of not yet load gamepage*/
      gameObj = {}
      gameObj.provider = provider
      gameObj.type = type
      gameObj.code = 0
      gameObj.name = provider
      gameObj.locale = [
        {
          name: provider
        }
      ]
      gameObj.imageCdn = _mediaUrl + '/menu/' + type + '/' + provider + '.webp'
    }

    if (gametype != 'sportsbook') {
      // retargeting
      // srtmCommands.push({
      //     event: "srt.retargeting",
      //     payload: {
      //         casinoEvent: {
      //             game: {
      //                 id: gameObj.code,
      //                 name: gameObj.locale && gameObj.locale.length > 0 ? gameObj.locale[0].name : '',
      //                 category: gametype,
      //                 image: gameObj.imageCdn ? gameObj.imageCdn : _mediaUrl+'/game_icons/en/'+gameObj.provider+'/'+gameObj.code+'_'+gameObj.id+'.jpg',
      //                 provider: {
      //                     id: gameObj.provider,
      //                     game: gameObj.code,
      //                 },
      //             },
      //             event: {
      //                 type: "page_view",
      //             },
      //             version: "1-0-0",
      //         },
      //     },
      // });
      //betslip
      srtmCommands.push({
        event: 'srt.betslip',
        payload: {
          casinoEvent: {
            game: {
              id: gameObj.code,
              name: gameObj.locale && gameObj.locale.length > 0 ? gameObj.locale[0].name : '',
              category: gametype,
              image: gameObj.imageCdn ? gameObj.imageCdn : _mediaUrl + '/game_icons/en/' + gameObj.provider + '/' + gameObj.code + '_' + gameObj.id + '.jpg',
              provider: {
                id: gameObj.provider,
                game: gameObj.code
              }
            },
            event: {
              type: 'page_view'
            },
            version: '1-0-0'
          }
        }
      })
    } else {
      //remove sport retargeting since we got no enough data at our end
      // srtmCommands.push({
      //   event: "srt.retargeting",
      //   payload: {
      //     sportsEvent: {
      //       match_id: "",
      //       sr_match_id: "",
      //       team_home_name: "",
      //       team_home_name_short: "",
      //       team_home_logo: "",
      //       team_away_name: "",
      //       team_away_name_short: "",
      //       team_away_logo: "",
      //       scheduled: "",
      //       status: "",
      //       tournament_name: "",
      //       sport: gameObj.provider,
      //       odds_home: "",
      //       odds_draw: "",
      //       odds_away: "",
      //       language: this.getLanguage(),
      //     },
      //   },
      // });
    }
  } catch (ex) {
    console.log(ex)
  }
}

function getDialCode() {
  return SHARED.DEFAULT_CURRENCY == 'BDT' ? '880' : '91'
}

var MD5 = function(d) {
  var r = M(V(Y(X(d), 8 * d.length)))
  return r.toLowerCase()
}

function M(d) {
  for (var _, m = '0123456789ABCDEF', f = '', r = 0; r < d.length; r++) (_ = d.charCodeAt(r)), (f += m.charAt((_ >>> 4) & 15) + m.charAt(15 & _))
  return f
}

function X(d) {
  for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0
  for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32
  return _
}

function V(d) {
  for (var _ = '', m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode((d[m >> 5] >>> m % 32) & 255)
  return _
}

function Y(d, _) {
  ;(d[_ >> 5] |= 128 << _ % 32), (d[14 + (((_ + 64) >>> 9) << 4)] = _)
  for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
    var h = m,
      t = f,
      g = r,
      e = i
    ;(f = md5_ii(
      (f = md5_ii(
        (f = md5_ii(
          (f = md5_ii(
            (f = md5_hh(
              (f = md5_hh(
                (f = md5_hh(
                  (f = md5_hh(
                    (f = md5_gg(
                      (f = md5_gg(
                        (f = md5_gg(
                          (f = md5_gg(
                            (f = md5_ff(
                              (f = md5_ff(
                                (f = md5_ff(
                                  (f = md5_ff(
                                    f,
                                    (r = md5_ff(r, (i = md5_ff(i, (m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936)), f, r, d[n + 1], 12, -389564586)), m, f, d[n + 2], 17, 606105819)),
                                    i,
                                    m,
                                    d[n + 3],
                                    22,
                                    -1044525330
                                  )),
                                  (r = md5_ff(r, (i = md5_ff(i, (m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897)), f, r, d[n + 5], 12, 1200080426)), m, f, d[n + 6], 17, -1473231341)),
                                  i,
                                  m,
                                  d[n + 7],
                                  22,
                                  -45705983
                                )),
                                (r = md5_ff(r, (i = md5_ff(i, (m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416)), f, r, d[n + 9], 12, -1958414417)), m, f, d[n + 10], 17, -42063)),
                                i,
                                m,
                                d[n + 11],
                                22,
                                -1990404162
                              )),
                              (r = md5_ff(r, (i = md5_ff(i, (m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682)), f, r, d[n + 13], 12, -40341101)), m, f, d[n + 14], 17, -1502002290)),
                              i,
                              m,
                              d[n + 15],
                              22,
                              1236535329
                            )),
                            (r = md5_gg(r, (i = md5_gg(i, (m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510)), f, r, d[n + 6], 9, -1069501632)), m, f, d[n + 11], 14, 643717713)),
                            i,
                            m,
                            d[n + 0],
                            20,
                            -373897302
                          )),
                          (r = md5_gg(r, (i = md5_gg(i, (m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691)), f, r, d[n + 10], 9, 38016083)), m, f, d[n + 15], 14, -660478335)),
                          i,
                          m,
                          d[n + 4],
                          20,
                          -405537848
                        )),
                        (r = md5_gg(r, (i = md5_gg(i, (m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438)), f, r, d[n + 14], 9, -1019803690)), m, f, d[n + 3], 14, -187363961)),
                        i,
                        m,
                        d[n + 8],
                        20,
                        1163531501
                      )),
                      (r = md5_gg(r, (i = md5_gg(i, (m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467)), f, r, d[n + 2], 9, -51403784)), m, f, d[n + 7], 14, 1735328473)),
                      i,
                      m,
                      d[n + 12],
                      20,
                      -1926607734
                    )),
                    (r = md5_hh(r, (i = md5_hh(i, (m = md5_hh(m, f, r, i, d[n + 5], 4, -378558)), f, r, d[n + 8], 11, -2022574463)), m, f, d[n + 11], 16, 1839030562)),
                    i,
                    m,
                    d[n + 14],
                    23,
                    -35309556
                  )),
                  (r = md5_hh(r, (i = md5_hh(i, (m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060)), f, r, d[n + 4], 11, 1272893353)), m, f, d[n + 7], 16, -155497632)),
                  i,
                  m,
                  d[n + 10],
                  23,
                  -1094730640
                )),
                (r = md5_hh(r, (i = md5_hh(i, (m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174)), f, r, d[n + 0], 11, -358537222)), m, f, d[n + 3], 16, -722521979)),
                i,
                m,
                d[n + 6],
                23,
                76029189
              )),
              (r = md5_hh(r, (i = md5_hh(i, (m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487)), f, r, d[n + 12], 11, -421815835)), m, f, d[n + 15], 16, 530742520)),
              i,
              m,
              d[n + 2],
              23,
              -995338651
            )),
            (r = md5_ii(r, (i = md5_ii(i, (m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844)), f, r, d[n + 7], 10, 1126891415)), m, f, d[n + 14], 15, -1416354905)),
            i,
            m,
            d[n + 5],
            21,
            -57434055
          )),
          (r = md5_ii(r, (i = md5_ii(i, (m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571)), f, r, d[n + 3], 10, -1894986606)), m, f, d[n + 10], 15, -1051523)),
          i,
          m,
          d[n + 1],
          21,
          -2054922799
        )),
        (r = md5_ii(r, (i = md5_ii(i, (m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359)), f, r, d[n + 15], 10, -30611744)), m, f, d[n + 6], 15, -1560198380)),
        i,
        m,
        d[n + 13],
        21,
        1309151649
      )),
      (r = md5_ii(r, (i = md5_ii(i, (m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070)), f, r, d[n + 11], 10, -1120210379)), m, f, d[n + 2], 15, 718787259)),
      i,
      m,
      d[n + 9],
      21,
      -343485551
    )),
      (m = safe_add(m, h)),
      (f = safe_add(f, t)),
      (r = safe_add(r, g)),
      (i = safe_add(i, e))
  }
  return Array(m, f, r, i)
}

function md5_cmn(d, _, m, f, r, i) {
  return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m)
}

function md5_ff(d, _, m, f, r, i, n) {
  return md5_cmn((_ & m) | (~_ & f), d, _, r, i, n)
}

function md5_gg(d, _, m, f, r, i, n) {
  return md5_cmn((_ & f) | (m & ~f), d, _, r, i, n)
}

function md5_hh(d, _, m, f, r, i, n) {
  return md5_cmn(_ ^ m ^ f, d, _, r, i, n)
}

function md5_ii(d, _, m, f, r, i, n) {
  return md5_cmn(m ^ (_ | ~f), d, _, r, i, n)
}

function safe_add(d, _) {
  var m = (65535 & d) + (65535 & _)
  return (((d >> 16) + (_ >> 16) + (m >> 16)) << 16) | (65535 & m)
}

function bit_rol(d, _) {
  return (d << _) | (d >>> (32 - _))
}

function getFingerprints() {
  var timestamp = new Date().getTime()
  var navigator_info = window.navigator
  var screen_info = window.screen
  var uid = navigator_info.mimeTypes.length
  uid += navigator_info.userAgent.replace(/\D+/g, '')
  uid += navigator_info.plugins.length
  uid += screen_info.height || ''
  uid += screen_info.width || ''
  uid += screen_info.pixelDepth || ''
  uid += timestamp
  var result = MD5(uid)
  console.log(result)
  return result
}

function getLoginPopup() {
  return DevicePlatform.POPUPLOGIN
}

function getPopup() {
  return DevicePlatform.POPUP
}

function initializePageDialogProperty() {
  let initPageDialog = {
    title: locale.getMessage(`label.system`),
    dialogXButton: this.closePageDialog,
    messageTitle: '',
    message: [],
    button: []
  }
  return initPageDialog
}

function getPlatform() {
  let type = DevicePlatform.DESKTOP
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/is) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    type = DevicePlatform.MOBILE
  } else {
    type = DevicePlatform.DESKTOP
  }
  return type
}

function IsIos() {
  if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/is) || navigator.userAgent.match(/iPod/i)) {
    return true
  }
}

function getHostname() {
  return window.location.origin
}

function getHost() {
  return window.location.host
}

function setCookie(name, value, day = 100) {
  let date = new Date()
  let expiration = new Date(date.setDate(date.getDate() + day))
  let cookie = escape(name) + '=' + escape(value) + ';expires=' + expiration + '; path=/'

  if (name === 'af_code') {
    cookie += ';samesite=none;secure' // Append SameSite attribute for af_code cookie
  }

  document.cookie = cookie
}

function getCookie(name) {
  let key = name + '='
  let cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(key) === 0) {
      return cookie.substring(key.length, cookie.length)
    }
  }
  return null
}

function removeCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

function getCurrency() {
  var currencySession = localStorage.getItem(SESSION.CURRENCY)
  if (currencySession == '' || currencySession == null) {
    setCurrency(SHARED.DEFAULT_CURRENCY)
  }
  return localStorage.getItem(SESSION.CURRENCY)
}

function setCurrency(value) {
  localStorage.setItem(SESSION.CURRENCY, value)
}

function getLanguage() {
  var languageCookie = getCookie(SESSION.LANGUAGE)
  if (languageCookie == '' || languageCookie == null) {
    setCookie(SESSION.LANGUAGE, SHARED.DEFAULT_LANGUAGE)
    languageCookie = SHARED.DEFAULT_LANGUAGE
  }
  return languageCookie
}

function getRegionLocale() {
  var regionLocale = getCookie(SESSION.REGION_LOCALE)
  if (regionLocale == '' || regionLocale == null) {
    const defaultRegionLocale = SHARED.DEFAULT_LANGUAGE + '-' + SHARED.DEFAULT_CURRENCY.substring(0, 2)
    setCookie(SESSION.REGION_LOCALE, defaultRegionLocale)
    regionLocale = defaultRegionLocale
  }
  return regionLocale
}

function setLanguage(value) {
  localStorage.setItem(SESSION.LANGUAGE, value)
}

function isAuthenticated() {
  let isLoggedIn = localStorage.getItem(SESSION.TOKEN)
  let result = true

  if (!isLoggedIn) {
    //check if user has logged in to the system
    result = false
  }

  return result
}

function getLocalStorage(key) {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

function setLocalStorage(key, value, ttl) {
  const now = new Date()

  const item = {
    value: value,
    expiry: now.getTime() + ttl * 60000
  }
  localStorage.setItem(key, JSON.stringify(item))
}

// let existingIframe = null;

// function openPopupInIframe(url, title) {
//     if (existingIframe) {
//         existingIframe.src = url;
//         return;
//     }
//     const container = document.createElement('div'); // Create a container div
//     container.style.position = 'fixed';
//     container.style.bottom = '-100%'; // Start with the container below the viewport
//     container.style.left = '0';
//     container.style.width = '100%';
//     container.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
//     container.style.height = '100%';
//     container.style.zIndex = '9999';
//     container.style.transition = 'bottom 0.5s'; // Add a transition for the 'bottom' property
//     document.body.appendChild(container);
//
//     const iframe = document.createElement('iframe');
//     iframe.src = url;
//     iframe.title = title;
//     iframe.style.position = 'fixed';
//     iframe.style.width = '100%';
//     iframe.style.height = `94%`;
//     iframe.style.border = 'none';
//     iframe.style.bottom = '0';
//     iframe.style.left = '0';
//
//     container.appendChild(iframe); // Append iframe to the container
//
//     const closeButton = document.createElement('button');
//     closeButton.textContent = 'X'; // Button text
//     closeButton.style.position = 'absolute';
//     closeButton.style.color = '#fff';
//     closeButton.style.backgroundColor = 'rgba(0, 0, 0, 0.25)';
//     closeButton.style.top = '0';
//     closeButton.style.right = '0';
//     closeButton.style.height = '6%';
//     closeButton.style.width = '50px';
//     closeButton.style.zIndex = '10000';
//     closeButton.addEventListener('click', () => {
//         container.style.bottom = '-100%'; // Slide out the container when the close button is clicked
//         setTimeout(() => {
//             document.body.removeChild(container); // Remove the container after the animation is complete
//         }, 100);
//         // Reset the existingIframe variable to null
//         existingIframe = null;
//     });
//
//     container.appendChild(closeButton); // Append close button to the container
//
//     const image = document.createElement('img');
//     image.src = '/static/image/home/logo.webp'; // Replace with the actual path to your image
//     image.style.position = 'absolute';
//     image.style.top = '0'; // Adjust top position as needed
//     image.style.left = '15px'; // Adjust left position as needed
//     image.style.width = '20%';
//     image.style.padding = '10px';
//     image.style.zIndex = '10000'; // Higher z-index to be above the iframe
//
//     container.appendChild(image); // Append image to the container
//
//     // Trigger the animation by setting the 'bottom' property to 0 after a slight delay
//     setTimeout(() => {
//         container.style.bottom = '0';
//     }, 100);
//
//     existingIframe = iframe;// Store the reference to the iframe
// }
let existingIframe = null

function openPopupInIframe(url, title) {
  // if (window !== window.top) {
  //     // If we are in an iframe, use the parent window to control the existing iframe
  //     parent.openPopupInIframe(url, title);
  //     return;
  // }
  if (!existingIframe) {
    const container = document.createElement('div') // Create a container div
    container.style.position = 'fixed'
    container.style.bottom = '-100%' // Start with the container below the viewport
    container.style.left = '0'
    container.style.width = '100%'
    container.style.backgroundColor = 'rgba(0, 0, 0, 0.9)'
    container.style.height = '100%'
    container.style.zIndex = '9999'
    container.style.transition = 'bottom 0.5s' // Add a transition for the 'bottom' property
    document.body.appendChild(container)

    const iframe = document.createElement('iframe')
    iframe.src = url
    iframe.title = title
    iframe.id = 'launchGame_iframe'
    iframe.style.position = 'fixed'
    iframe.style.width = '100%'
    iframe.style.height = `94%`
    iframe.style.border = 'none'
    iframe.style.bottom = '0'
    iframe.style.left = '0'

    container.appendChild(iframe) // Append iframe to the container

    const closeButton = document.createElement('button')
    closeButton.textContent = 'X' // Button text
    closeButton.style.position = 'absolute'
    closeButton.style.color = '#fff'
    closeButton.style.backgroundColor = 'rgba(0, 0, 0, 0.25)'
    closeButton.style.top = '0'
    closeButton.style.right = '0'
    closeButton.style.height = '6%'
    closeButton.style.width = '50px'
    closeButton.style.zIndex = '10000'
    closeButton.addEventListener('click', () => {
      container.style.bottom = '-100%' // Slide out the container when the close button is clicked
      setTimeout(() => {
        document.body.removeChild(container) // Remove the container after the animation is complete
      }, 100)
      // Reset the existingIframe variable to null
      existingIframe = null
    })

    container.appendChild(closeButton) // Append close button to the container

    const image = document.createElement('img')
    image.src = '/static/image/home/logo.webp' // Replace with the actual path to your image
    image.style.position = 'absolute'
    image.style.top = '0' // Adjust top position as needed
    image.style.left = '10px' // Adjust left position as needed
    image.style.width = '115px'
    image.style.padding = '10px'
    image.style.zIndex = '10000' // Higher z-index to be above the iframe

    container.appendChild(image) // Append image to the container

    // Trigger the animation by setting the 'bottom' property to 0 after a slight delay
    // setTimeout(() => {
    //     container.style.bottom = '0';
    // }, 100);
    document.body.appendChild(container)
    setTimeout(() => {
      container.style.bottom = '0'
    }, 100)
  } else {
    existingIframe.src = url // Reuse the existing iframe by updating its src
    const container = existingIframe.parentNode
    container.style.bottom = '0' // Ensure the container is visible
  }
}

function openPopup(url, title, popupWidth, popupHeight) {
  let isAndroidMobile = localStorage.getItem(CACHE_KEY.IS_ANDROID)
  if (isAndroidMobile != null) {
    isAndroidMobile = JSON.parse(isAndroidMobile)
  }
  if (isAndroidMobile != null && isAndroidMobile.value) {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

    const systemZoom = width / window.screen.availWidth
    const left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft
    const top = (height - popupHeight) / 2 / systemZoom + dualScreenTop
    const newWindow = window.open(
      '',
      title,
      `
            width=${popupWidth}, 
            height=${popupHeight}, 
            top=${top}, 
            left=${left}
            `
    )

    newWindow.document.write('Redirecting...')
    newWindow.location.href = url
  } else {
    window.open(url, '_blank')
  }

  // if (window.hasOwnProperty('focus')) newWindow.focus()
}

function downloadAPK() {
  //  window.open(SHARED.MEDIA_DOMAIN + '/krikya/app/Krikya.apk?v=1')
  window.open('https://app.krikya11.com')
}

function isAndroid() {
  return /(android)/i.test(navigator.userAgent)
}

function openNewTab(url, title, popupWidth, popupHeight) {
  setTimeout(() => {
    window.open(url, '_blank')
  })
}

function setMetaTag(property, content) {
  var selector = document.querySelector('meta[name="' + property + '"]')
  selector.setAttribute('content', content)
}

function setTitle(title) {
  document.title = title
}

function setCanonical(link) {
  link = window.location.origin + window.location.pathname.replace(/\/$/, '')
  let canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) {
    document.querySelector('link[rel="canonical"]').setAttribute('href', link)
  } else {
    var linkDocument = document.createElement('link')
    linkDocument.href = link
    linkDocument.rel = 'canonical'
    document.getElementsByTagName('head')[0].appendChild(linkDocument)
  }
}

function setHreflangLinks(link) {
  const existingLink = document.querySelector('link[rel="alternate"][hreflang="x-default"]')

  // Remove existing hreflang link with the specified lang attribute
  if (existingLink) {
    existingLink.parentNode.removeChild(existingLink)
  }

  // Create and append the new hreflang link
  const linkDocument = document.createElement('link')
  linkDocument.rel = 'alternate'
  linkDocument.hreflang = 'x-default'
  linkDocument.href = link
  document.getElementsByTagName('head')[0].appendChild(linkDocument)
}

function setHreflangLinksen(link) {
  const existingLink = document.querySelector('link[rel="alternate"][hreflang="en-BD"]')

  // Remove existing hreflang link with the specified lang attribute
  if (existingLink) {
    existingLink.parentNode.removeChild(existingLink)
  }

  // Create and append the new hreflang link
  const linkDocument = document.createElement('link')
  linkDocument.rel = 'alternate'
  linkDocument.hreflang = 'en-BD'
  linkDocument.href = link
  document.getElementsByTagName('head')[0].appendChild(linkDocument)
}

function setHreflangLinksbd(link) {
  const existingLink = document.querySelector('link[rel="alternate"][hreflang="bn-BD"]')

  // Remove existing hreflang link with the specified lang attribute
  if (existingLink) {
    existingLink.parentNode.removeChild(existingLink)
  }

  // Create and append the new hreflang link
  const linkDocument = document.createElement('link')
  linkDocument.rel = 'alternate'
  linkDocument.hreflang = 'bn-BD'
  linkDocument.href = link
  document.getElementsByTagName('head')[0].appendChild(linkDocument)
}

function setSchema(currentLanguage) {
  let schema = document.getElementsByClassName('aioseop-schema')[0]
  if (currentLanguage == 'en') {
    schema.text =
      '{"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://www.krikya-play.com/#organization","url":"https://www.krikya-play.com/","name":"Krikya, Live Casino Bangladesh, Online Casino Bangladesh, Cricket Casino 2022","sameAs":[]},{"@type":"WebSite","@id":"https://www.krikya-play.com/#website","url":"https://www.krikya-play.com/","name":"Krikya, Bangladesh Cricket Betting, Cricket Betting Site Bangladesh, Cricket Exchange, Best Cricket Betting","publisher":{"@id":"https://www.krikya-play.com/#organization"}},{"@type":"WebPage","@id":"https://www.krikya-play.com/#webpage","url":"https://www.krikya-play.com/","inLanguage":"ENH","name":"Krikya, Cricket Exchange Download, Bangladesh Cricket Betting, Cricket Exchange","isPartOf":{"@id":"https://www.krikya-play.com/#website"},"breadcrumb":{"@id":"https://www.krikya-play.com/#breadcrumblist"},"description":"Krikya Bet, Online Casino Bangladesh, Live Casino Bangladesh, Cricket Exchange Download, Indian Premier League, Bangladesh Cricket Betting, Online Slot Bangladesh, Cricket Casino 2022.","about":{"@id":"https://www.krikya-play.com/#organization"}},{"@type":"BreadcrumbList","@id":"https://www.krikya-play.com/#breadcrumblist","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.krikya-play.com/","url":"https://www.krikya-play.com/","name":"Krikya, IPL, Indian Premier League, Crazy Time, Online Slots Bangladesh, Online Slot Bangladesh"}}]}]}'
  } else if (currentLanguage == 'bd') {
    schema.text =
      '{"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://www.krikya-play.com/#organization","url":"https://www.krikya-play.com/","name":"Krikya, লাইভ ক্যাসিনো বাংলাদেশ, অনলাইন ক্যাসিনো বাংলাদেশ, ক্রিকেট ক্যাসিনো","sameAs":[]},{"@type":"WebSite","@id":"https://www.krikya-play.com/#website","url":"https://www.krikya-play.com/","name":"Krikya, বাংলাদেশ ক্রিকেট বাজি , ক্রিকেট বেটিং সাইট বাংলাদেশ , ক্রিকেট এক্সচেঞ্জ , সেরা ক্রিকেট বেটিং","publisher":{"@id":"https://www.krikya-play.com/#organization"}},{"@type":"WebPage","@id":"https://www.krikya-play.com/#webpage","url":"https://www.krikya-play.com/","inLanguage":"BEN","name":"Krikya, ক্রিকেট এক্সচেঞ্জ ডাউনলোড, বাংলাদেশ ক্রিকেট বেটিং, ক্রিকেট এক্সচেঞ্জ","isPartOf":{"@id":"https://www.krikya-play.com/#website"},"breadcrumb":{"@id":"https://www.krikya-play.com/#breadcrumblist"},"description":"ক্রিকেট ক্যাসিনো, বাংলাদেশ ক্রিকেট বাজি, ক্রিকেট বেটিং সাইট বাংলাদেশ, ক্রিকেট এক্সচেঞ্জ, সেরা ক্রিকেট বেটিং, অনলাইন ক্যাসিনো বাংলাদেশ, অনলাইন ক্যাসিনো 2022, ইন্ডিয়ান প্রিমিয়ার লিগ, পাগলামী সময়, অনলাইন স্লট বাংলাদেশ, বিশ্বস্ত সেরা অনলাইন ক্রিকেট এক্সচেঞ্জ","about":{"@id":"https://www.krikya-play.com/#organization"}},{"@type":"BreadcrumbList","@id":"https://www.krikya-play.com/#breadcrumblist","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.krikya-play.com/","url":"https://www.krikya-play.com/","name":"Krikya, আইপিএল, ইন্ডিয়ান প্রিমিয়ার লিগ, ক্রেজি টাইম, অনলাইন স্লট বাংলাদেশ , অনলাইন স্লট বাংলাদেশ"}}]}]}'
  }
}
